import { render, staticRenderFns } from "./tabs_content.vue?vue&type=template&id=7e15e62e"
import script from "./tabs_content.vue?vue&type=script&lang=js"
export * from "./tabs_content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports